



























import Vue, { PropType } from 'vue';
import { LinkRequest } from "@/common/types/BrokerLinks";
import { TradingServer } from '@/utils/Api';
import { FETCH_LINKREQUESTS, LinkRequestFetchParameter } from '@/common/store/modules/DepotStore';

export default Vue.extend({
  props: {
    value: {
      default: false,
      type: Boolean
    },
    linkRequest: {
      type: Object as PropType<LinkRequest | null>
    }
  },
  data () {
    return {
      editAccountNumberDialogValue: '',
      loading: false,
      error: ''
    };
  },
  methods: {
    async save () {
      try {
        if (!this.linkRequest) {
          throw 'link request not found';
        }
  
        await TradingServer({
          method: 'PATCH',
          url: '/v1/broker-accounts/{broker}/applications/{id}/account-number',
          headers: { 'Content-Type': 'application/json' },
          urlParams: {
            broker: this.linkRequest.broker,
            id: this.linkRequest.id
          },
          data: this.editAccountNumberDialogValue.trim()
        });

        this.$emit('input', false);
        this.$store.dispatch(FETCH_LINKREQUESTS, { requesterId: this.$route.params.id } as LinkRequestFetchParameter);
      } catch (error) {
        this.error = error.response.data && error.response.data.errors.length ? error.response.data.errors[0].message : error;
      } finally {
        this.loading = false;
      }
    }
  },
  watch: {
    value (current: boolean, previous: boolean) {
      if (current === true && previous === false) {
        this.editAccountNumberDialogValue = this.linkRequest && this.linkRequest.accountNo ? this.linkRequest.accountNo : '';
        this.error = '';
      }
    }
  }
});
